module.exports = __webpack_public_path__ + "img/AramKakayFalah-PanjaMoriTanyayi.db1bda8c.jpg";